import PropertyConstruction from ".";
import FullPageModal from "@/modules/common/components/ui-kit/full-page-modal/full-page-modal";
import { Track } from "../../types";

export default function PropertyConstructionMobileTab({
  open,
  onClose,
  track,
}: Readonly<{
  track: Track;
  open: boolean;
  onClose: () => void;
}>) {
  return (
    <FullPageModal isOpen={open} onClose={onClose} title="Construction">
      <PropertyConstruction track={track} />
    </FullPageModal>
  );
}
